// @ts-nocheck
// ACL resolution for /cti2, in one place so every surface answers the same
// way. Rule: superadmin passes; an explicit `false` on a module the user's
// ACL does carry is a deny; a module absent from the ACL map is "not
// configured" and stays permissive — the same stance
// utilities/agentAcl.ts already takes for edit_options, and the reason an
// agent whose ACL never lists the admin-only Breaks module does not lose
// their own break button.
import { MODULE_ACL, USER_ROLES } from '@/utilities/constant';
import { getUser } from '@/utilities/setting';

function resolve(moduleOps, moduleName, operation) {
  if (getUser()?.role === USER_ROLES.SUPERADMIN) return true;
  const entry = moduleOps?.[moduleName];
  if (!entry) return true;
  return Boolean(entry[operation]);
}

/** True only when the ACL carries the module and explicitly denies it. */
export function isDenied(moduleOps, moduleName, operation) {
  return !resolve(moduleOps, moduleName, operation);
}

export function teamAccess(moduleOps) {
  return {
    canReadAgents: resolve(moduleOps, MODULE_ACL.AGENTS, 'read'),
    canSnoop: resolve(moduleOps, MODULE_ACL.AGENTS, 'read'),
    canReadCallGroup: resolve(moduleOps, MODULE_ACL.CALL_GROUP, 'read'),
    canReadLeads: resolve(moduleOps, MODULE_ACL.AGENT_LEADS, 'read'),
  };
}

export function breakAccess(moduleOps) {
  return { canUseBreaks: resolve(moduleOps, MODULE_ACL.BREAKS, 'read') };
}

export const ACL_DENIED_TEXT = {
  agents: 'ACL permission missing for Agents.',
  callGroup: 'ACL permission missing for Call Groups.',
  breaks: 'ACL permission missing for Breaks.',
  leads: 'ACL permission missing for Agent Leads.',
};

/**
 * A "team lead" here isn't a distinct backend role in the general case — the
 * JWT it issues still carries `role_ccagent`; the actual signal is an
 * `access: 'team_lead'` flag on the agent record. `USER_ROLES.CALL_CENTRE_
 * TEAM_LEAD` covers the (rarer) distinct-role case too. Used by
 * AgentPortalPage (which view to render) and Topbar (which labels to show) —
 * neither is team-dashboard-specific code, which is why this lives here
 * rather than in team/teamModel.ts.
 */
export function isTeamLeadUser(userData) {
  return (
    userData?.role === USER_ROLES.CALL_CENTRE_TEAM_LEAD ||
    userData?.agentData?.access === 'team_lead'
  );
}
